import React, { useState, useEffect } from 'react';
import axios from '../../api/AxiosConfig';
import Header from './Header';
import Hero from '../Blog/Hero';
import Footer from '../Blog/Footer';
import PostCard from './PostCard'; // You must create this component if it doesn't exist

const BlogPage = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const res = await axios.get('/blog');
        setPosts(res.data.data);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching blog posts:', err);
        setLoading(false);
      }
    };
    fetchPosts();
  }, []);

  const filteredPosts = posts.filter((post) =>
    post.title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-900 text-slate-800 dark:text-slate-100 selection:bg-indigo-500 selection:text-white">
      <Header searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
      <Hero searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
      <div className="max-w-6xl mx-auto px-4 py-8">
        {loading ? (
          <p className="text-center text-lg">Loading blog posts...</p>
        ) : filteredPosts.length > 0 ? (
          filteredPosts.map((post) => (
            <PostCard key={post._id} post={post} />
          ))
        ) : (
          <p className="text-center text-lg">No blog posts found.</p>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default BlogPage;
